import React, { useEffect } from "react";
import {
  withSitecoreContext,
} from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";
import { QueryParamsConst } from "../../constants/query-params.constants";
import useQueryParams from "../../hooks/use-query-params.effect";
import Pagination from "./components/Pagination";
import SearchFilterDropdown from "./components/SearchFilterDropdown";
import { useTranslation } from "react-i18next";
import { documentService } from "../../utils/window.utils.js"
const { useState } = React;


const SearchModule = (props) => {
  const results = props?.fields?.apidata?.items;
  const search = props?.fields?.apidata?.searchPage;
  const numberOfResults = props?.fields?.apidata?.totalSearchResults;
  const [page, setPage] = useQueryParams(QueryParamsConst.PAGE, "1");
  const itemPerPage = 10;
  const pages: number = Math.ceil(numberOfResults / itemPerPage);
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);
  

  let urlParams;
  let currentPage: number = 0;
  if (typeof window !== "undefined") {
    urlParams = new URLSearchParams(window.location.search);
  }
  if (urlParams != undefined) {
    currentPage =
      urlParams.get("page") != undefined && urlParams.get("page") != ""
        ? urlParams.get("page")
        : 1;
  }

  let queryText;
  if (urlParams != undefined) {
    queryText =
      urlParams.get("q") != undefined && urlParams.get("q") != ""
        ? urlParams.get("q")
        : "";
  }
  let type;
  if (urlParams != undefined) {
    type =
      urlParams.get("type") != undefined && urlParams.get("type") != ""
        ? urlParams.get("type")
        : "";
  }
  let pageID;
  if (urlParams != undefined) {
    pageID =
      urlParams.get("pageID") != undefined && urlParams.get("pageID") != ""
        ? urlParams.get("pageID")
        : "";
  }

  let isPressRelease;
  if (urlParams != undefined) {
    isPressRelease =
      urlParams.get("ispr") != undefined && urlParams.get("ispr") != ""
        ? urlParams.get("ispr")
        : "";
  }

  const [qT, setValue] = useState(queryText);
  const handleChange = (e) => setValue(e.target.value);
  const hasSearched = queryText != undefined && queryText != "" ? true : false;
  let baseUrl = "";
  if (typeof window !== "undefined") {
    baseUrl = window.location.origin;
  }

  useEffect(() => {
    if (documentService()) {
      if (qT.length > 0) {
        documentService().getElementById("searchInputCrossSvg").style.display = "block";
      } else {
        documentService().getElementById("searchInputCrossSvg").style.display = "none";
      }
    }
  }, [qT]);

  const activeFieldSet = () => {
    if (documentService()) {
      documentService()?.getElementById("searchFieldset").classList.add("active");
    }
  };
  const removeActiveFieldSet = () => {
    if (document) {
      documentService()?.getElementById("searchFieldset").classList.remove("active");
    }
  };
  const onInputSearchKeyup = (e) => {
    if (e.keyCode == "13") {
      //enter
      searchSitecore();
    }
  };

  const searchSitecore = () => {
    const currentPage = 1;
    const valSearch = (
      document && document.getElementById("searchFieldsetInput") as HTMLInputElement
    ).value;
    if (valSearch && valSearch != "") {
      let redirectUrl = "";
      if (type && type != "" && pageID && pageID != "") {
        redirectUrl = `${search}?q=${valSearch}&type=${type}&pageID=${pageID}`;
      } else {
        redirectUrl = `${search}?q=${valSearch}&page=${currentPage}&take=${itemPerPage}`; //&filters=Vehicles
      }
      if (typeof window !== "undefined") {
        window.location.href = redirectUrl;
      }
    }
  };

  const clearInputSearch = () => {
    setValue("");
  };

  return (
    <>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      ></meta>
      <section className={"search-module container"}>
        <div className={"content-main search-content"}>
          <div className="search-fieldset-wrapper">
            <fieldset
              className="search-fieldset"
              id="searchFieldset"
              onFocus={activeFieldSet}
              onBlur={removeActiveFieldSet}
            >
              <input
                id="searchFieldsetInput"
                type="text"
                className="search-fieldset-input"
                onKeyUp={onInputSearchKeyup}
                value={qT}
                onChange={handleChange}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="search-input-lens-svg"
                onClick={searchSitecore}
              >
                <path
                  d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 15L21 21"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="search-input-cross-svg"
                id="searchInputCrossSvg"
                onClick={clearInputSearch}
              >
                <path
                  d="M16 16L8 8"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 8L8 16"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </fieldset>
          </div>
          <div className="search-all-results">
            {/* <Pagination page={page} pages={pages} setPage={setPage} /> */}
            {numberOfResults > 0 ? (
              <>
                <div className="search-result-container">
                  <p className="search-result-text">
                    {" "}
                    <span className="total-result">{numberOfResults}</span> {t("CnhindustrialcomResults")}{" "}
                    <span className="total-result">{queryText}</span>
                  </p>

                <div className='dropDownSection'>
                  <div className='filterSection dropDownDiv'>
                    <SearchFilterDropdown
                      queryText={queryText}
                      pageID={pageID}
                      type={type}
                      currentPage={currentPage ?? 0}
                      itemPerPage={itemPerPage}
                      search={search}
                      isPressRelease={isPressRelease}
                    />
                  </div>
                </div>

                </div>
                {results?.map((r, i) => {
                  return (
                    <a href={r.Link} className="search-title-result-anchor">
                      <div className="search-result" key={i}>
                        <div className="parent-flex">
                          <p className="search-title-result left margin-right-auto">
                            {r.Title}
                          </p>
                          <pfe-icon
                            size={24}
                            icon="cnh-arrow-forward"
                            class="search-title-result right"
                          />
                        </div>

                        <p
                          className="search-descr-result"
                          dangerouslySetInnerHTML={{ __html: r.Description }}
                        ></p>
                      </div>
                    </a>
                  );
                })}
                {numberOfResults > itemPerPage ? (
                  <Pagination page={page} pages={pages} setPage={setPage} />
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                {hasSearched == true ? (
                  <div className="search-no-results-wrapper">
                    <h3 className="search-no-results">
                    {t("CnhindustrialcomNoResults")}
                    </h3>
                    <div className='dropDownSection'>
                      <div className='filterSection dropDownDiv'>
                        <SearchFilterDropdown
                          queryText={queryText}
                          pageID={pageID}
                          type={type}
                          currentPage={currentPage}
                          itemPerPage={itemPerPage}
                          search={search}
                          isPressRelease={isPressRelease}
                        />
                      </div>
                </div>
                  </div>
                  
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default withSitecoreContext()(SearchModule);
